import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import CienciaEvento from "./CienciaEvento";
import { Button } from "primereact/button";
import ContribuicaoService from "../../../../services/contribuicao.service";
import ToastService from "../../../../../vendors/services/toastService";
import { Mensagem } from "../../../../shared/mensagem/Mensagem";
import Environment from "../../../../../environments/environment";

interface Props {
  show: any;
  onHide: any;
  handleFinalizar: any;
}

export default function ModalCienciaEvento({
  show,
  onHide,
  handleFinalizar,
}: Props) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [receberNotificacao, setReceberNotificacao] = useState(false);
  const [send, setSend] = useState(false);
  const [captchaValid, setCaptchaValid] = useState(false);
  const captchaRef: any = useRef(null);
  const service = new ContribuicaoService();
  const [cienciaEventoOutros, setCienciaEventoOutros] = useState(null);

  const handleNaoClick = () => {
    onHide();
  };

  const validaSave = () => {
    setSend(true);
    if (!selectedOption) {
      ToastService.showWarn(Mensagem.PREENCHA_TODOS_CAMPOS);
      return;
    }
    if (Environment.getShowCaptcha() && !captchaRef.current.getValue()) {
      ToastService.showWarn("Responda ao captcha.");
      return;
    }

    if (!Environment.getShowCaptcha()) {
      handleFinalizar({
        CienciaEventoOutros: cienciaEventoOutros,
        cdCienciaEvento: selectedOption,
        stReceberNotificacao: receberNotificacao,
      });
    } else {
      service.start();
      service
        .validaCaptcha(captchaRef.current.getValue())
        .then((res: any) => {
          service.stop();
          if (!res.data) {
            ToastService.showWarn("Captcha inválido.");
            return;
          }
          handleFinalizar({
            CienciaEventoOutros: cienciaEventoOutros,
            cdCienciaEvento: selectedOption,
            stReceberNotificacao: receberNotificacao,
          });
        })
        .catch((err) => {
          ToastService.showWarn("Captcha inválido.");
          service.stop();
        });
    }
  };

  useEffect(() => {
    if (show) {
      setSelectedOption(null);
      setCienciaEventoOutros(null);
      setReceberNotificacao(false);
      setSend(false);
    }
  }, [show]);

  const dialogFooter = (
    <div className="mce-footer">
      <Button
        label="Salvar e Continuar"
        className="finalizar-sucess p-button--confirm"
        disabled={captchaValid}
        onClick={() => validaSave()}
      />
    </div>
  );

  return (
    <>
      <Dialog
        className="mce-dialog"
        onHide={() => onHide()}
        visible={show}
        draggable={false}
        footer={dialogFooter}
        showHeader={false}
      >
        <CienciaEvento
          checked={receberNotificacao}
          setChecked={setReceberNotificacao}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          cienciaEventoOutros={cienciaEventoOutros}
          setCienciaEventoOutros={setCienciaEventoOutros}
          send={send}
          captchaRef={captchaRef}
        />
      </Dialog>
    </>
  );
}
